import {
  AnyContext,
  AnyRoute,
  ResolveFullPath,
  ResolveId,
  ResolveParams,
  RouteConstraints,
  Route as TRoute,
} from "@tanstack/react-router";
import React from "react";

export const useRouteFullPath = <
  TParentRoute extends RouteConstraints["TParentRoute"] = AnyRoute,
  TPath extends RouteConstraints["TPath"] = "/",
  TFullPath extends RouteConstraints["TFullPath"] = ResolveFullPath<
    TParentRoute,
    TPath
  >,
  TCustomId extends RouteConstraints["TCustomId"] = string,
  TId extends RouteConstraints["TId"] = ResolveId<
    TParentRoute,
    TCustomId,
    TPath
  >,
  TSearchValidator = undefined,
  TParams = ResolveParams<TPath>,
  TRouterContext = AnyContext,
  TRouteContextFn = AnyContext,
  TBeforeLoadFn = AnyContext,
  TLoaderDeps extends Record<string, any> = {},
  TLoaderFn = undefined,
  TChildren = unknown,
>(
  Route: TRoute<
    TParentRoute,
    TPath,
    TFullPath,
    TCustomId,
    TId,
    TSearchValidator,
    TParams,
    TRouterContext,
    TRouteContextFn,
    TBeforeLoadFn,
    TLoaderDeps,
    TLoaderFn,
    TChildren
  >,
) => {
  const routeFullPathRef = React.useRef(Route.fullPath); // #TODO this is due to Route.fullPath being undefined on hmr
  const routeFullPath = routeFullPathRef.current;
  React.useEffect(() => {
    routeFullPathRef.current = Route.fullPath ?? routeFullPathRef.current;
  }, [Route.fullPath]);
  return routeFullPath;
};
